module.exports = __webpack_public_path__ + "87f82fd1b18df8da95e32886bf753ba9.svg";